import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const LanguageToggle = ({ className = '' }) => {
  const { t, i18n } = useTranslation('common')
  const { saveLanguagePreference, user } = useAuth()
  const nextLanguageLabel = i18n.language === 'en' ? t('spanish') : t('english')

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en'
    i18n.changeLanguage(newLang)
    // Save preference for authenticated users
    if (user && saveLanguagePreference) {
      saveLanguagePreference(newLang)
    }
  }

  return (
    <button
      onClick={toggleLanguage}
      className={`
        flex items-center space-x-2 px-2.5 py-1.5 text-sm font-medium sm:px-3 sm:py-2 sm:text-base
        text-gray-700 hover:text-[#FF1B54] hover:bg-[#FFF0F4]
        rounded-md transition-colors duration-200
        focus:outline-none focus:ring-2 focus:ring-[#FF1B54]/30 focus:ring-offset-2
        ${className}
      `}
      aria-label={t('switchTo', { language: nextLanguageLabel })}
      title={t('switchTo', { language: nextLanguageLabel })}
    >
      <span className="hidden text-gray-600 sm:inline">
        {t('language')}:
      </span>
      <span className="font-semibold text-[#FF1B54]">
        {i18n.language === 'en' ? t('english') : t('spanish')}
      </span>
      <span className="text-xs text-gray-400 sm:text-sm">
        ({i18n.language === 'en' ? 'ES' : 'EN'})
      </span>
    </button>
  )
}

export default LanguageToggle
